import React, { useEffect, useRef, useState } from "react";
import { url } from "../api/index";

import moment from "moment";
import axios from "axios";
import { useQuery } from "react-query";
import { ApiCall } from "../api/ApiCall";
import { getPrice } from "../api/index";
import { buildFormData } from "../buildFormData";
import MedicalInfo from "./MedicalInfo";
import PatientInfo from "./PatientInfo";
import Payment from "./Payment";
import Scheduleinfo from "./Scheduleinfo";

const Index = () => {
  const formData = new FormData();
  const [isConsentAccepted, setIsConsentAccepted] = useState(false);
  const [step, setStep] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [parentName, setParentName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [ageInYear, setAgeInYear] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [gender, setGender] = useState("male");
  const [medical, setMedical] = useState("Select Medical");
  const [comment, setComment] = useState("");
  const [files, setFiles] = useState(null);
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const [date, selectDate] = useState(null);
  const [info, setInfo] = useState();
  const [consultationType, setConsultationType] = useState(
    "written_report_analysis"
  );
  const [slotId, setSlotId] = useState("");
  const [doctorId, setDoctorId] = useState("");
  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState({});
  const [pubKeyStripe, setPubKeyStripe] = useState(null);
  const token = localStorage.getItem("token");

  const { isLoading, isFetching, data, isError } = useQuery(
    ["getPrice"],
    getPrice,
    {
      retry: 1,
      retryDelay: 500,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        setAmount(data?.data?.pricing);
      },
    }
  );
  let pubKeyResponse;
  useEffect(async () => {
    try {
      pubKeyResponse = await ApiCall({
        route: "payment/stripe-key",
        token: token,
        params: {},
        verb: "get",
        baseurl: true,
      });
      console.log(pubKeyResponse.response);
      setPubKeyStripe(pubKeyResponse?.response.stripeApiKey);
    } catch (error) {
      console.log(error);
    }
  }, []);

  let price = null;
  consultationType == "phone_call"
    ? (price = amount?.audioCall)
    : consultationType == "video_call"
    ? (price = amount?.videoCall)
    : (price = amount?.writtenReportAnalysis);

  // let formdata = useRef(new FormData());
  // console.log("FILES", file);

  const onCreateConsultation = async (e) => {
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("email", email);
    formData.append("phoneNumber", phoneNumber);
    formData.append("state", state);
    formData.append("city", city);
    formData.append("gender", gender);
    formData.append("medical", medical);
    formData.append("comment", comment);
    formData.append("ageInYear", ageInYear);
    formData.append("consultationType", consultationType);
    formData.append("price", price);
    formData.append("dateOfBirth", moment(date).local().format("YYYY-MM-DD"));
    formData.append("timeSlot[endTime]", endTime);
    formData.append("timeSlot[startTime]", startTime);

    if (slotId && doctorId) {
      formData.append("slotId", slotId);
      formData.append("doctorId", doctorId);
    }

    if (files && files?.length > 0) {
      for (let i = 0; i < files?.length; i++) {
        formData?.append(`files[${i}]`, files[i], files[i].name);
      }
    }

    try {
      if (consultationType == "written_report_analysis") {
        const res = await ApiCall({
          route: "consultations/create-writtent-report",
          token: token,
          params: formData,
          verb: "post",
        });

        if (res?.status == "200") {
          // setInfo(res?.response?.data);

          setShow(true);
        } else {
          console.log("error", res.response);
        }
      } else {
        const res = await ApiCall({
          route: "consultations/create-consultation",
          token: token,
          params: formData,
          verb: "post",
        });
        if (res?.status == "200") {
          setInfo(res?.response);

          setShow(true);
        } else {
          console.log("error", res.response);
        }
      }
    } catch (error) {
      console.log("saga get create Consultation error -- ", error);
    }
  };

  switch (step) {
    case 0:
      return (
        <PatientInfo
          firstName={firstName}
          lastName={lastName}
          city={city}
          state={state}
          setStep={setStep}
          ageInYear={ageInYear}
          setFirstName={setFirstName}
          setLastName={setLastName}
          setEmail={setEmail}
          setPhoneNumber={setPhoneNumber}
          setAgeInYear={setAgeInYear}
          setState={setState}
          setCity={setCity}
          setGender={setGender}
          parentName={parentName}
          setParentName={setParentName}
          date={date}
          selectDate={selectDate}
          isConsentAccepted={isConsentAccepted}
          setIsConsentAccepted={setIsConsentAccepted}
        />
      );
    case 1:
      return (
        isConsentAccepted && (
          <MedicalInfo
            medical={medical}
            comment={comment}
            files={files}
            setStep={setStep}
            setMedical={setMedical}
            setComment={setComment}
            // medical={medical}
            setFiles={setFiles}
          />
        )
      );
    case 2:
      return (
        isConsentAccepted && (
          <>
            <Scheduleinfo
              setStep={setStep}
              consultationType={consultationType}
              setConsultationType={setConsultationType}
              onCreateConsultation={onCreateConsultation}
              setSlotId={setSlotId}
              setDoctorId={setDoctorId}
              // createConsultation={CreateConsultation}
              show={show}
              setShow={setShow}
              setStartTime={setStartTime}
              setEndTime={setEndTime}
              slotId={slotId}
              price={price}
            />
            {show ? (
              <Payment
                formdata={formData}
                temp={info}
                consultationType={consultationType}
                firstName={firstName}
                email={email}
                show={show}
                setStep={setShow}
                setShow={setShow}
                amount={amount}
                price={price}
                pubKeyStripe={pubKeyStripe}
              />
            ) : null}
          </>
        )
      );
  }
};

export default Index;
